'use client';

import { getQueryParam } from '@/utils/url';
import { Banner } from '@payloadcms/ui';
import React, { useEffect, useState } from 'react';

import { oauthErrorMessage } from '../constants';

const OAuthErrorMessage: React.FC = () => {
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  useEffect(() => {
    const error = getQueryParam('error');

    if (error) {
      // eslint-disable-next-line react-hooks/set-state-in-effect -- read OAuth error from URL on mount (client-only)
      setErrorMessage(oauthErrorMessage(error));

      const newUrl = new URL(window.location.href);
      newUrl.searchParams.delete('error');
      window.history.replaceState({}, '', newUrl.toString());
    }
  }, []);

  if (!errorMessage) {
    return null;
  }

  return (
    <div style={{ marginBottom: 16 }}>
      <Banner type="error">{errorMessage}</Banner>
    </div>
  );
};

export default OAuthErrorMessage;
